import { Component, input, InputSignal } from "@angular/core";

/**
 * Component used as header to each question
 * The header contains:
 * - an icon
 * - the category title
 * - category progress (e.g. "Kategori 1 av 6")
 * - a progress bar for progress within the current category
 */
@Component({
  selector: "bko-category-header",
  imports: [],
  templateUrl: "./category-header.html",
  styleUrl: "./category-header.scss",
})
export class CategoryHeader {
  readonly categoryTitle: InputSignal<string> = input("Nærmiljø");
  // Current category
  readonly categoryNumber: InputSignal<number> = input(1);
  readonly categoryTotal: InputSignal<number> = input(6);

  // Current question number (relative to current category)
  readonly currentQuestion: InputSignal<number> = input(5);
  // Total number of questions in current category
  readonly totalQuestions: InputSignal<number> = input(10);

  readonly categoryIconUri: InputSignal<string> = input(undefined);
  readonly categoryIconType: InputSignal<string> = input(undefined);
}
